'use client';

import React from 'react';

const CountryCodeContext = React.createContext<string | null | undefined>(undefined);

export function CountryCodeProvider({
  children,
  value,
}: React.PropsWithChildren<{ value: string }>) {
  return <CountryCodeContext value={value}>{children}</CountryCodeContext>;
}

export default function useCountryCode() {
  const context = React.use(CountryCodeContext);

  if (context === undefined) {
    throw new Error('useCountryCode must be used within a CountryCodeProvider');
  }

  return context;
}
